import { useState } from "react";
import { Send } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

export default function NewsletterSubscribe() {
  const { t } = useLanguage();
  const n = t.newsletter;
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("sending");
    try {
      const res = await fetch(`/api/newsletter`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) {
        setStatus("error");
        return;
      }
      const text = await res.text();
      let data;
      try { data = JSON.parse(text); } catch { data = { success: true }; }
      if (data.success) {
        setStatus(data.message && data.message.includes("already") ? "already" : "success");
        setEmail("");
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    <section data-testid="newsletter-section" className="border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="max-w-2xl mx-auto text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="h-px w-12 bg-[#D4AF37]" />
            <Send size={14} className="text-[#D4AF37]" />
            <div className="h-px w-12 bg-[#D4AF37]" />
          </div>
          <h2 className="text-2xl md:text-3xl text-white mb-3" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            {n.heading}
          </h2>
          <p className="text-slate-400 text-sm leading-relaxed mb-8">{n.desc}</p>

          {status === "success" ? (
            <p data-testid="newsletter-success" className="text-[#D4AF37] text-sm font-medium">{n.success}</p>
          ) : status === "already" ? (
            <p data-testid="newsletter-already" className="text-[#D4AF37] text-sm font-medium">{n.alreadySubscribed}</p>
          ) : (
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row items-stretch gap-3 max-w-lg mx-auto">
              <input
                data-testid="newsletter-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => { setEmail(e.target.value); setStatus("idle"); }}
                placeholder={n.placeholder}
                className="flex-1 bg-[#162A45] border border-slate-700 focus:border-[#D4AF37] text-white text-sm px-5 py-3 outline-none transition-colors duration-300 placeholder:text-slate-600"
              />
              <button
                data-testid="newsletter-submit-btn"
                type="submit"
                disabled={status === "sending"}
                className="bg-[#D4AF37] text-[#0B1221] text-xs font-bold uppercase tracking-widest px-8 py-3 hover:bg-[#F59E0B] transition-colors duration-300 disabled:opacity-60 flex items-center justify-center gap-2"
              >
                {status === "sending" ? n.sending : n.cta}
                <Send size={12} />
              </button>
            </form>
          )}
          {status === "error" && (
            <p data-testid="newsletter-error" className="text-red-400 text-xs mt-3">{n.error}</p>
          )}
        </div>
      </div>
    </section>
  );
}
